export const colors = {
    black: '#000000',
    transparentBlack: 'rgba(0, 0, 0, 0.2)',
    white: '#FFFFFF',
    greenLight: '#DCEFB7',
    greenDark: '#20494D',
    grey: '#808080',
    greyLight: '#EAEBEB',
    primary: '#EF8200',
    topChoice: '#E85522',
    yellow: '#FFD06C',
};
